export default __webpack_public_path__ + "static/loox-c5d7a97afab74eab0925e7fc1a192044.png";